import GiftCardItem, { GIFT_CARD_ITEM_TYPE } from './GiftCardItem';

export default GiftCardItem;
export { GIFT_CARD_ITEM_TYPE };
